<template>  
    <div :style="shu.yangshi" class="zidingyi_wenzi">leibiao</div> 	
</template>

<script>
export default {
  name: 'liebiao',
  props: {
       shu: {
		   type:Object,
		   default(){
			   return {wenzi:'输入文字',yangshi:{}}
		   }
		}
  },
  
}
</script>



